<template>
    <div class="videoWrapper">
        <div @click="replayVideo" :class="['replay',showReplayBtn==true ? 'active':'']">
            <div class="caption">Replay</div>
        </div>
        <video autoplay id="ve1" @click="onVideoClick">
            <source src="videos/seven.mp4" type="video/mp4">
        </video>
    </div>
</template>
<script>

export default 
{
    name: "AppVideo",
    props: {        
        src:
        {
            default:'',
            type:String
        }
    },
    data()
    {
        return {
            selectedIndex:0,
            videoElement:null,
            showReplayBtn:false
        }
    },
    created()
    {
    },
    destroyed()
    {
        this.videoElement.removeEventListener('ended',this.onVideoEnded);
    },
    mounted()
    {
        //this.initText(false);
        this.videoElement = document.getElementById("ve1");
        this.videoElement.addEventListener('ended',this.onVideoEnded,false);
    },
    watch:{
    },
    methods:
    {
        replayVideo()
        {
            this.showReplayBtn=false;
            let ve = this.videoElement;
            ve.play();            
        },
        onVideoEnded()
        {
            this.showReplayBtn=true;//remove it when playing !!!!!
        },
        onVideoClick()
        {
            let ve = this.videoElement;
            //alert(this.videoElement);
            if (ve.paused) {
                ve.play();
            } else {
                ve.pause();
            }
        }
    }

};
</script>

<style>
    .videoWrapper
    {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%; /* 16:9 aspect ratio */
    }
    .videoWrapper video
    {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1000;
    }
    .videoWrapper .replay
    {
        position: absolute;
        top: 0px;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1010;
        background-color: rgba(0, 0, 0, 0.7);
        opacity: 0;
        transition: all ease 0.5s;
        pointer-events: none;
    }    
    .videoWrapper .replay.active
    {
        opacity: 1;
        pointer-events: all;
    }
    .videoWrapper .replay .caption
    {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        color: #4e9cdb;
        border: solid 1px #4e9cdb;
        border-radius: 30px;
        padding: 20px 30px;
        display: inline-block;
    }        
</style>